import { render } from "./FloorContainer.vue?vue&type=template&id=2716fede&scoped=true"
import script from "./FloorContainer.vue?vue&type=script&lang=js"
export * from "./FloorContainer.vue?vue&type=script&lang=js"

import "./FloorContainer.vue?vue&type=style&index=0&id=2716fede&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Тестовое TrueConf\\true_conf\\elevator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2716fede"]])

export default __exports__